import { render, staticRenderFns } from "./FinishedIdentifications.vue?vue&type=template&id=d31dfc50&scoped=true"
import script from "./FinishedIdentifications.vue?vue&type=script&lang=js"
export * from "./FinishedIdentifications.vue?vue&type=script&lang=js"
import style0 from "./FinishedIdentifications.vue?vue&type=style&index=0&id=d31dfc50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d31dfc50",
  null
  
)

export default component.exports